import { useState } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { signInReturnTarget, clearSignInReturn } from "../utils/signInReturn";

/**
 * Sends a shopper who has just signed in back to where they were, once.
 * The target is read on first render and the stored copy cleared, so a later
 * sign-in from the homepage never inherits an old cart or checkout path.
 */
const ReturnAfterSignIn = () => {
  const location = useLocation();
  const [target] = useState(() => {
    const resolved = signInReturnTarget(location);
    clearSignInReturn();
    return resolved;
  });
  return <Redirect to={target} />;
};

export default ReturnAfterSignIn;
